import React from "react";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";

interface NavbarProps {
  user: any;
  signOut: any;
}

export const LabpadreNavbar = (props: NavbarProps) => {
  return (
    <Navbar bg="primary" variant="dark">
      <Container>
        <Navbar.Brand href="/">
          <img alt="Labpadre rocket logo" src="lp_rocket.png" />
        </Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link href="/">Helper</Nav.Link>
          <Nav.Link href="/commentators">Commentators</Nav.Link>
          {/* <Nav.Link href="/stream-layout">Stream Layout</Nav.Link> */}
        </Nav>
        <Navbar.Brand>{props.user ? props.user.username : null}</Navbar.Brand>
        <Button variant="light" onClick={props.signOut}>
          Sign Out
        </Button>
      </Container>
    </Navbar>
  );
};
